module.exports = __webpack_public_path__ + "img/Price Tracking.a00aa044.svg";